// if (process.env.NODE_ENV === 'production') {
//   module.exports = require('./APIClient')
// } else {
//   module.exports = require('./MockAPIClient')
// }

module.exports = require('./APIClient')
